// Generated by ts-to-zod
import { z } from 'zod';
import { schemaSectionSchema } from '../../../schemas/models/schemaSection.schema';

export const formulasInfoPayloadSchema = z.object({
  schemaContent: z.array(schemaSectionSchema),
});

export const formulasInfoResponseSchema = z.object({
  results: z.array(
    z.object({
      formula: z.string().optional(),
      type: z
        .union([
          z.literal('formula'),
          z.literal('reasoning'),
          z.literal('lookup'),
        ])
        .optional(),
      dependencies: z.array(z.string()),
      id: z.string(),
      context: z.array(z.string()).optional(),
    })
  ),
});
